export const ProApp = () => <p>I'm the pro app</p>;
